import CalculatorLabels from "../lib/CalculatorLabels";
import {maxBy, minBy} from "lodash";
import ConfiguratorOptions from "./ConfiguratorOptions";
import {ScreenHelper} from "../lib/ScreenHelper";

export const ChartOptions = (datasets, calculationsStyle = null, collectionName = 'cooling_performances') => {

  const xAxesLabelName = collectionName === 'cooling_performances' ? 'oilFlowRate' : 'oilFlowRate'
  const yAxesLabelName = collectionName === 'cooling_performances' ? 'specificCoolingCapacity' : 'oilPressure'

  const setRendered = {
    afterRender: function (chart) {
      if (!chart.$rendered) {
        chart.$rendered = true;
      }
    }
  }

  return {
    type: 'line',
    plugins: [setRendered],
    responsive: true,
    data: {
      labels: [],
      datasets: datasets,
    },
    options: {
      responsive: true,
      title: {
        display: false,
      },
      tooltips: {
        mode: 'dataset',
        intersect: true,
        position: 'nearest',
        callbacks: {
          label: function () {
            return false;
          },

          title: function (tooltipItems, data) {
            const datasetIndex = tooltipItems[0].datasetIndex
            return data.datasets[datasetIndex]?.name ?? tooltipItems[0].yLabel
          }
        }
      },
      legend: {
        display: false
      },
      hover: {
        mode: 'nearest',
        animationDuration: 0,
        intersect: true
      },
      scales: {
        xAxes: [{
          type: 'linear',
          display: true,
          scaleLabel: {
            display: true,
            labelString: CalculatorLabels(calculationsStyle).get(xAxesLabelName, false),
            fontSize: ScreenHelper.getResponsiveLabelSize()
          },
          ticks: {
            beginAtZero: false,
            stepSize: calculateStepSize(datasets)
          },
          gridLines: {
            display: false
          }
        }],
        yAxes: [{
          display: true,
          scaleLabel: {
            display: true,
            labelString: CalculatorLabels(calculationsStyle).get(yAxesLabelName, false),
            fontSize: ScreenHelper.getResponsiveLabelSize()
          },
        }]
      },
      animation: {
        duration: 0 // general animation time
      },
      responsiveAnimationDuration: 0 // animation duration after a resize
    }
  }
}

function getMaxXValue(datasets) {
  return maxBy(datasets.map(set => maxBy(set.data, 'x')), 'x')?.x;
}

const calculateStepSize = (datasets) => {
  return ConfiguratorOptions.calculateXStepSizeByMaxValue(getMaxXValue(datasets))
}

export default ChartOptions

export const PrintOptions = () => {

  const labelSize = ScreenHelper.getRelationalFontSize()

  return {
    options: {
      scales: {
        xAxes: [{
          ticks: {fontSize: labelSize}
        }],
        yAxes: [{
          ticks: {fontSize: labelSize}
        }]
      }
    }
  }
}
